import { themes } from 'kb-shared';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px 16px 28px 16px;
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2);
  &:hover {
    box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.4);
  }
  @media screen and ${themes.queries.minDesktop} {
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and ${themes.queries.minDesktop} {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;

export const TitleText = styled.span`
  font-size: 24px;
  color: ${themes.colors.neutral.primaryNavy};
`;

export const SubtitleText = styled.span`
  font-size: 14px;
  color: ${themes.colors.neutral.primaryNavy};
  white-space: pre-wrap;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 18px;

  @media screen and ${themes.queries.minDesktop} {
    padding-top: 0px;
    width: 247px;
    flex-shrink: 0;
  }
`;
